import React, {FC} from 'react'
import {observer} from 'mobx-react'
import {useTranslation} from 'react-i18next'
import useStore from 'store'
import {DeleteButtonSm} from './styles'

interface DeleteModuleButtonProps {
    // The module this section edits. Deleting needs its module_id, so the
    // button stays disabled until the module exists.
    module?: { module_id?: number | null, title?: string | null } | null
    // What to call the module in the confirmation - the tab name reads best.
    moduleLabel: string
    currentOrgId: number | undefined
    // Let the section clear whatever it was holding about the module.
    onDeleted?: () => void
}

// Removing a module is not undoable, so it always goes through the warning
// modal first - same text the "add new module" dialog uses.
const DeleteModuleButton: FC<DeleteModuleButtonProps> = ({ module, moduleLabel, currentOrgId, onDeleted }) => {
    const {modulesStore, uiStore} = useStore()
    const {t} = useTranslation('communitySettings')

    const moduleId = module?.module_id

    const onDelete = () => uiStore.openWarningModal({
        text: `${t`remove:moduleRemove`} ${moduleLabel}`,
        secondText: module?.title ? `${t`remove:moduleName`} ${module.title}` : '',
        okAction: async () => {
            if (!moduleId) return
            await modulesStore.deleteModule(moduleId)
            if (currentOrgId) await modulesStore.getCommunityModulesAndFeatures(currentOrgId)
            onDeleted?.()
        }
    })

    return (
        <DeleteButtonSm disabled={!moduleId} onClick={onDelete}>
            {t`common:deletion`}
        </DeleteButtonSm>
    )
}

export default observer(DeleteModuleButton)
